<template>
  <v-app>
    <v-main>
      <router-view />
      <app-notification />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
  import AppNotification from './components/AppNotification.vue'
</script>
